import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";
import {withApollo} from "react-apollo";

import "../style.css";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import { userData } from "../graph";


class StatusModal extends React.Component {
    
    onStatusBtnClick(id, status, event) {
        const newStatus = !status; //opposite of current status
        
        this.props.ManagerUserStatus({
            variables: { uid: id , status: newStatus}  
        }).then(() => {
            // $('#statusUserModal').modal('hide');
            this.props.onStatusModalClose();

            if (this.props.onStatusModalCallback)
                this.props.onStatusModalCallback(id, newStatus);
        });
    }

    render(){
        let btnType = "";
        let headerTitle = "Deactivate Confirmation";
        let bodyTextType = "deactivate";
        let id = "";
        let status = false;
        const user = this.props.user;
        
        if (user) {
            status = user.active;

            if (status) {
                btnType = "btn btn-danger";
            }
            else {
                btnType = "btn btn-warning";
                headerTitle = "Activate Confirmation";
                bodyTextType = "activate";
            }

            id = user.uid;
        }


        return(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={headerTitle}
              onConfirm={this.onStatusBtnClick.bind(this, id, status)}
              onCancel={() => this.props.onStatusModalClose()}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
              cancelBtnCssClass={
                this.props.classes.button + " " + this.props.classes.danger
              }
              confirmBtnText={bodyTextType.toUpperCase()}
              cancelBtnText="Cancel"
              showCancel
              >
                Are you sure you want to {bodyTextType} User ID <b>#{id}</b>?
            </SweetAlert>
        )
    }
}

export default  withStyles(sweetAlertStyle)((userData)(withApollo(StatusModal)));


// WEBPACK FOOTER //
// ./src/views/users/components/StatusModal.js